module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('a-swipe'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "top-content"
  }, _vm._l((_vm.recommendList), function(item) {
    return _c('div', {
      key: "item.aid",
      staticClass: "top-item col-xs-6",
      on: {
        "click": function($event) {
          _vm.recommendPlay(item.aid, item.title, item.description, item.author)
        }
      }
    }, [_c('img', {
      staticClass: "show-img",
      attrs: {
        "src": item.pic,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "top-info"
    }, [_c('span', {
      staticClass: "top-tag"
    }, [_vm._v("【" + _vm._s(item.typename) + "】")]), _vm._v(" "), _c('span', {
      staticClass: "top-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "top-user"
    }, [_c('span', {
      staticClass: "top-author"
    }, [_vm._v(_vm._s(item.author))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" "), _c('span', {
      staticClass: "watch-num fr"
    }, [_vm._v(_vm._s(item.play))])])])])
  }))], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "monkey-topLine"
  }, [_c('img', {
    staticClass: "fl",
    attrs: {
      "src": "http://imgs.aixifan.com/cms/2017_03_03/1488528971079.gif?imageView2/1/w/100/h/100",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("猴山头条")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fb64896"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/recommend.vue
// module id = 113
// module chunks = 0